module.exports = __webpack_public_path__ + "media/images/emotions/sebastiao-shame-917f9671a5ecd0033369a91fd87ee28b.svg";